<app-order-page [loading]="loadingLines$ | async"
                [expanding]="isExpanding$ | async"
                [orders]="orders$ | async"
                [cartProducts]="cartProducts$ | async"
                [currency]="currency$ | async"
                (onExpand)="expand()"
                (onAddCart)="addCart($event)"
                >
</app-order-page>
